import React from "react";
import { IFailureDetailsButtonProps } from "./FailureDetailsButtonInterfaces";
import CircleIcon from "@mui/icons-material/Circle";
import { useStyles } from "./FailureDetailsButton.styles";
import { Box, Typography } from "@mui/material";

export const FailureDetailsButton = ({ onClick, name, color }: IFailureDetailsButtonProps) => {
    const classes = useStyles();

    return (
        <button className={classes.button} type="button" onClick={onClick}>
            <Box className={classes.buttonBox}>
                {color && <CircleIcon sx={{ color: color }} />}
                <Typography className={classes.buttonText} variant="subtitle1">
                    {name}
                </Typography>
            </Box>
        </button>
    );
};
